import produce from 'immer';

import {
	CLOSE_REFUND_SERVICES_MODAL,
	RefundServicesActionTypes,
	SET_REFUND_SERVICES_LOADING,
	SET_REFUND_SERVICES_MODAL,
	SET_REFUND_SERVICES_SELECTED_PRODUCT_IDS
} from './actions';
import { RefundServicesState } from './types';

const initialState: RefundServicesState = {
	selectedProductIds: [],
	isLoading: false,
	modal: null
};

const refundServicesReducer = (state = initialState, { type, payload }: RefundServicesActionTypes) => {
	return produce(state, draft => {
		switch (type) {
			case SET_REFUND_SERVICES_SELECTED_PRODUCT_IDS: {
				draft.selectedProductIds = payload as number[];
				break;
			}

			case SET_REFUND_SERVICES_LOADING: {
				draft.isLoading = payload as boolean;
				break;
			}

			case SET_REFUND_SERVICES_MODAL: {
				draft.modal = payload as RefundServicesState['modal'];
				break;
			}

			case CLOSE_REFUND_SERVICES_MODAL: {
				draft.modal = null;
				break;
			}
		}
	});
};

export default refundServicesReducer;
